import { TypedActorNode } from "./_Base";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import {
  ActorConnectionPointType,
  PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES
} from "../utils/io/connections/Actor";
function typedVisibleOptions(type, otherParamVal = {}) {
  const val = PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES.indexOf(type);
  return { visibleIf: { type: val, ...otherParamVal } };
}
class ConstantActorParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.type = ParamConfig.INTEGER(PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES.indexOf(ActorConnectionPointType.FLOAT), {
      menu: {
        entries: PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES.map((name, i) => {
          return { name, value: i };
        })
      }
    });
    this.boolean = ParamConfig.BOOLEAN(0, typedVisibleOptions(ActorConnectionPointType.BOOLEAN));
    this.color = ParamConfig.COLOR([0, 0, 0], typedVisibleOptions(ActorConnectionPointType.COLOR));
    this.float = ParamConfig.FLOAT(0, typedVisibleOptions(ActorConnectionPointType.FLOAT));
    this.integer = ParamConfig.INTEGER(0, typedVisibleOptions(ActorConnectionPointType.INTEGER));
    this.string = ParamConfig.STRING("", typedVisibleOptions(ActorConnectionPointType.STRING));
    this.vector2 = ParamConfig.VECTOR2([0, 0], typedVisibleOptions(ActorConnectionPointType.VECTOR2));
    this.vector3 = ParamConfig.VECTOR3([0, 0, 0], typedVisibleOptions(ActorConnectionPointType.VECTOR3));
    this.vector4 = ParamConfig.VECTOR4([0, 0, 0, 0], typedVisibleOptions(ActorConnectionPointType.VECTOR4));
  }
}
const ParamsConfig = new ConstantActorParamsConfig();
const _ConstantActorNode = class extends TypedActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "constant";
  }
  initializeNode() {
    this.io.connection_points.set_output_name_function((index) => _ConstantActorNode.OUTPUT_NAME);
    this.io.connection_points.set_expected_input_types_function(() => []);
    this.io.connection_points.set_expected_output_types_function(() => [this._currentConnectionType()]);
  }
  _currentConnectionType() {
    if (this.pv.type == null) {
      console.warn(`${this.type()} actor node type not valid`);
    }
    const connectionType = PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES[this.pv.type];
    if (connectionType == null) {
      console.warn(`${this.type()} actor node type not valid`);
    }
    return connectionType;
  }
  currentParam() {
    const type = PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES[this.pv.type];
    switch (type) {
      case ActorConnectionPointType.BOOLEAN: {
        return this.p.boolean;
      }
      case ActorConnectionPointType.COLOR: {
        return this.p.color;
      }
      case ActorConnectionPointType.FLOAT: {
        return this.p.float;
      }
      case ActorConnectionPointType.INTEGER: {
        return this.p.integer;
      }
      case ActorConnectionPointType.STRING: {
        return this.p.string;
      }
      case ActorConnectionPointType.VECTOR2: {
        return this.p.vector2;
      }
      case ActorConnectionPointType.VECTOR3: {
        return this.p.vector3;
      }
      case ActorConnectionPointType.VECTOR4: {
        return this.p.vector4;
      }
    }
    return this.p.boolean;
  }
  setConstantType(type) {
    this.p.type.set(PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES.indexOf(type));
  }
  outputValue(context) {
    return this.currentParam().value;
  }
};
export let ConstantActorNode = _ConstantActorNode;
ConstantActorNode.OUTPUT_NAME = "val";
